import { render, staticRenderFns } from "./MainLedgerCard5.vue?vue&type=template&id=90e90332&scoped=true"
import script from "./MainLedgerCard5.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard5.vue?vue&type=script&lang=js"
import style1 from "./otvoreneStavke.css?vue&type=style&index=1&id=90e90332&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e90332",
  null
  
)

export default component.exports